import React, {Component} from 'react';
import {Button, Layout, Typography, Card} from "antd";
import OpenSheetMusicDisplay from "../../components/OpenSheetMusicDisplay";
import {StopOutlined} from '@ant-design/icons';
import {
    drawExercise,
    playCorrect,
    playIncorrect
} from "./helper";
import {MusicXml} from "./MusicXml";
import {keys} from "./keys";

const {Content} = Layout;

const exercises = keys.filter(item => item);
const responses = [...keys].sort((a, b) => a.name > b.name ? 1 : -1);

export default class KeysTestContainer extends Component {

    state = {
        current: null,
        result: 0,
        exerciseNo: 0
    }

    start() {
        this.setState({current: drawExercise(exercises)});
    }

    stop() {
        this.setState({current: null, exerciseNo: 0, result: 0});
    }

    check(value) {
        let {result, exerciseNo} = this.state;
        if (this.state.current.fifths === value.fifths) {
            playCorrect();
            result++;
        } else {
            playIncorrect();
            alert('Prawidłowa odpowiedź to: ' + this.state.current.name);
        }
        exerciseNo++;
        this.setState({result, exerciseNo, current: drawExercise(exercises)});
    }

    render() {
        return <Layout style={{background: '#fff', margin: '0 24px', padding: '0'}}>
            <Content style={{padding: '20px'}}>
                <div style={{textAlign: 'left'}}>
                    <Typography.Title level={3} style={{textTransform: 'uppercase', margin: '0'}}>
                        Tonacje. Test
                    </Typography.Title>

                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '10px',
                        justifyContent: 'center',
                        marginTop: '20px'
                    }}>

                        {
                            this.state.current ?
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}>
                                    <Card title={'Wynik'} style={{
                                        width: '250px',
                                        fontSize: '36px',
                                        textAlign: 'center',
                                        fontWeight: 'bold'
                                    }}
                                          bordered={true}
                                    >
                                        {this.state.result} / {this.state.exerciseNo}
                                    </Card>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: '5px'
                                    }}>
                                        <Typography.Title level={4} style={{margin: '0'}}>
                                            Jaka to tonacja?
                                        </Typography.Title>
                                        <div style={{width: '300px'}}>
                                            <OpenSheetMusicDisplay
                                                file={MusicXml.buildKeyMusicXML(this.state.current)}
                                                drawTitle={false}
                                                autoResize={true}
                                                backend={'svg'}
                                                drawPartNames={false}
                                                drawCredits={false}
                                                drawTimeSignatures={false}
                                                stretchLastSystemLine={true}
                                            />
                                        </div>
                                        <Button icon={<StopOutlined/>}
                                                onClick={() => this.stop()}>
                                            Zakończ
                                        </Button>
                                    </div>
                                    <p style={{marginTop: '10px'}}>Wskaż prawidłową odpowiedź:</p>
                                    <div style={{
                                        padding: '10px 10px',
                                        display: 'flex',
                                        gap: '10px',
                                        flexWrap: 'wrap',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        {
                                            responses.map(item => (
                                                <Card key={item.name}
                                                      style={{width: '150px', fontSize: '16px', textAlign: 'center'}}
                                                      hoverable={true}
                                                      bordered={true}
                                                      onClick={() => this.check(item)}
                                                >
                                                    {item.name}
                                                </Card>
                                            ))
                                        }
                                    </div>
                                </div> :
                                <Button type="primary"
                                        onClick={() => this.start()}>
                                    Start
                                </Button>
                        }
                    </div>
                </div>
            </Content>
        </Layout>
    }
}
